import scrollmagic from 'scrollmagic'
import { gsap, Linear } from "gsap"
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'

ScrollMagicPluginGsap(scrollmagic, gsap)
gsap.registerPlugin(MotionPathPlugin)
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

var controller = new scrollmagic.Controller(
  {
    globalSceneOptions:
      {
        triggerHook: 'onEnter',
        duration: '180%',
        offset: '-10%',
        reverse: true,
      },
  },
)

if ($('#parallax3').length) {
  new scrollmagic.Scene({ triggerElement: '#parallax3' }).setTween(
    '#parallax-image', 0.2, { y: '10%', ease: Linear.easeNone }).addTo(controller)

}
